import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import Icon from 'components/atoms/ListingsTable/Icon'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Typography from '@material-ui/core/Typography'
import buildUrl from '../../utils/apiHelpers'
import { myListingsIconUrl } from '../../utils/staticAssets'

function MoreOptionsDropdown (props) {
  const [anchorEl, setAnchorEl] = useState(null)

  function handleMenuItemClick () {
    setAnchorEl(null)
    if (props.isUpdating) props.isUpdating()
  }

  // Custom action items (e.g. Delete, and on mobile Boost / Mark as sold). An
  // action either runs an onClick handler or navigates via an href (used on
  // mobile for nav actions like Add photos / Edit that aren't default links).
  function renderActionItem (action) {
    if (action.href) {
      return (
        <MenuItem key={action.key} onClick={handleMenuItemClick} aria-label={action.label} className={`flex items-center action_${action.key}`}>
          <a href={buildUrl(action.href)} className='flex items-center justify-between' style={{ cursor: 'pointer' }} aria-label={action.label} data-source='seller-dashboard-listings'>
            {action.icon ? <ListItemIcon style={{ minWidth: '30px' }}>{action.icon}</ListItemIcon> : null}
            <Typography variant='inherit' className='vsd-listing-menu-item-label' style={{ fontSize: '14px' }}>{action.label}</Typography>
          </a>
        </MenuItem>
      )
    }

    return (
      <MenuItem
        key={action.key}
        onClick={() => { setAnchorEl(null); action.onClick() }}
        aria-label={action.label}
        className={`flex items-center action_${action.key}`}
      >
        {action.icon ? <ListItemIcon style={{ minWidth: '30px' }}>{action.icon}</ListItemIcon> : null}
        <Typography variant='inherit' className='vsd-listing-menu-item-label' style={{ fontSize: '14px' }}>{action.label}</Typography>
      </MenuItem>
    )
  }

  function renderMenuItem (url, img, text) {
    const className = text === 'Edit listing' ? 'flex items-center justify-between edit_listing' : 'flex items-center justify-between'
    const imageLink = myListingsIconUrl(`${img}.svg`)
    const href = buildUrl(url)

    return (
      <MenuItem onClick={handleMenuItemClick} aria-label={text}>
        <a href={href} className={className} style={{ cursor: 'pointer' }} aria-label={text} data-source='seller-dashboard-listings'>
          <ListItemIcon style={{ minWidth: '30px' }}>
            <img src={imageLink} alt={text} />
          </ListItemIcon>
          <Typography variant='inherit' className='vsd-listing-menu-item-label' style={{ fontSize: '14px' }}>{text}</Typography>
        </a>
      </MenuItem>
    )
  }

  function renderMenuItems () {
    const { status, id, p2p } = props.listing
    const pdpUrl = props.listing.linkToPDP
    const updatePriceUrl = '/listings/' + id + '/edit?#price-section'
    const editListingUrl = '/listings/' + id + '/edit'
    const showUpdatePriceOption = ['Published'].includes(status) && !p2p
    const showEditListingOption = ['Published', 'On hold', 'Action required'].includes(status)
    const showViewPdpOption = ['Published', 'On hold', 'Auto marked as stale'].includes(status)

    const actions = props.actions || []

    return (
      <div>
        {actions.map(renderActionItem)}
        {showUpdatePriceOption ? renderMenuItem(updatePriceUrl, 'update_price', 'Update price') : ''}
        {showEditListingOption ? renderMenuItem(editListingUrl, 'pencil', 'Edit listing') : ''}
        {showViewPdpOption ? renderMenuItem(pdpUrl, 'view_on_website', 'View on website') : ''}
      </div>
    )
  }

  function renderMenu () {
    return (
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        PaperProps={{
          style: {
            maxHeight: 'calc(100vh - 96px)',
            minWidth: '220px',
            maxWidth: 'calc(100vw - 32px)'
          }
        }}
      >
        {renderMenuItems()}
      </Menu>
    )
  }

  return (
    <div>
      <Button name='More' aria-controls='simple-menu' aria-haspopup='true' onClick={(e) => setAnchorEl(e.currentTarget)}>
        <Icon
          content='More'
          iconName='three_dots.svg'
        />
        {props.label ? <span className='ml-8' style={{ fontSize: '14px', textTransform: 'none' }}>{props.label}</span> : null}
      </Button>
      {renderMenu()}
    </div>
  )
}

export default MoreOptionsDropdown
